import { ApplyConversationFlagInReadingPaneState } from './actions/applyConversationFlagInReadingPane';
import { LoadConversationReadingPaneState } from './actions/loadConversationReadingPane';
import { LoadConversationReadingPaneForSingleMailItemSelectedState } from './actions/loadConversationReadingPaneForSingleMailItemSelected';
import { LoadItemReadingPaneForSingleMailItemSelectedState } from './actions/loadItemReadingPaneForSingleMailItemSelected';
import { ReloadReadingPaneState } from './actions/reloadReadingPane';
import { SetItemIdToScrollToState } from './actions/setItemIdToScrollTo';
import { UpdateLoadedConversationState } from './actions/updateLoadedConversation';
import ActionableMessageCardInItemViewState from './store/schema/ActionableMessageCardInItemViewState';
import DeeplinkId from './store/schema/DeeplinkId';
import ItemPartViewState from './store/schema/ItemPartViewState';
import ItemReadingPaneViewState from './store/schema/ItemReadingPaneViewState';
import SmartPillViewState from './store/schema/SmartPillViewState';
import { LazyAction, LazyImport, LazyModule, registerLazyOrchestrator } from 'owa-bundling';
import { ClientItemId } from 'owa-client-ids';
import deleteItemsStoreUpdate from 'owa-mail-actions/lib/triage/deleteItemsStoreUpdate';
import markConversationsAsReadStoreUpdate from 'owa-mail-actions/lib/triage/markConversationsAsReadStoreUpdate';
import markItemsAsReadStoreUpdate from 'owa-mail-actions/lib/triage/markItemsAsReadStoreUpdate';
import ConversationReadingPaneViewState from 'owa-mail-reading-pane-store/lib/store/schema/ConversationReadingPaneViewState';
import { ClientItem } from 'owa-mail-store';
import { InstrumentationContext } from 'owa-mail-store';
import { ItemMandatoryPropertiesCollectionChange } from 'owa-mail-store-actions';
import CollectionChange from 'owa-mail-store/lib/store/schema/CollectionChange';
import FlagType from 'owa-service/lib/contract/FlagType';
import Item from 'owa-service/lib/contract/Item';
import ItemId from 'owa-service/lib/contract/ItemId';

// Import orchestrators so they get registered

// webpackPrefetch is 2 means that the reading pane package could be prefetched ealier than
// the packages which have webpackPrefetch as true.
const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "ReadingPane", webpackPrefetch: 2 */ './lazyIndex')
);

// Export delay loaded actions
export let lazyLoadConversationReadingPane = new LazyAction(
    lazyModule,
    m => m.loadConversationReadingPane
);

export let lazyReloadReadingPane = new LazyAction(lazyModule, m => m.reloadReadingPane);

export let lazyApplyConversationFlagInReadingPane = new LazyAction(
    lazyModule,
    m => m.applyConversationFlagInReadingPane
);

export let lazyUpdateLoadedConversation = new LazyAction(
    lazyModule,
    m => m.updateLoadedConversation
);

export let lazyUpdateOnItemMandatoryPropertiesChange = new LazyAction(
    lazyModule,
    m => m.updateOnItemMandatoryPropertiesChange
);

export let lazyMoveReadingPaneToTab = new LazyAction(lazyModule, m => m.moveReadingPaneToTab);

export let lazyLoadConversationReadingPaneForSingleMailItemSelected = new LazyAction(
    lazyModule,
    m => m.loadConversationReadingPaneForSingleMailItemSelected
);

export let lazyPrint = new LazyAction(lazyModule, m => m.print);
export let lazySetItemIdToScrollTo = new LazyAction(lazyModule, m => m.setItemIdToScrollTo);
export let lazyLoadItemReadingPane = new LazyAction(lazyModule, m => m.loadItemReadingPane);

export let lazyLoadItemReadingPaneForSingleMailItemSelected = new LazyAction(
    lazyModule,
    m => m.loadItemReadingPaneForSingleMailItemSelected
);

const lazyInitializeStitches = new LazyAction(lazyModule, m => m.initializeStitches);

// Register lazy orchestrator
registerLazyOrchestrator(
    deleteItemsStoreUpdate,
    lazyModule,
    m => m.deleteItemsStoreUpdateOrchestrator
);
registerLazyOrchestrator(
    markConversationsAsReadStoreUpdate,
    lazyModule,
    m => m.markConversationsAsReadStoreUpdateOrchestrator
);
registerLazyOrchestrator(
    markItemsAsReadStoreUpdate,
    lazyModule,
    m => m.markItemsAsReadStoreUpdateOrchestrator
);

// Export delay loaded utilities
export let lazyGetLastestNonDraftItemId = new LazyImport(
    lazyModule,
    m => m.getLastestNonDraftItemId
);

export let lazyIsUnsupportedItem = new LazyImport(lazyModule, m => m.isUnsupportedItem);
export let lazySetCalendarInlineCompose = new LazyAction(
    lazyModule,
    m => m.setCalendarInlineComposeViewState
);

export let lazyReplyByMeeting = new LazyAction(lazyModule, m => m.replyByMeeting);

// Export synchronous actions
export { default as setItemReadingPaneViewState } from './actions/setItemReadingPaneViewState';
export { default as setItemPrintPaneViewState } from './actions/setItemPrintPaneViewState';

// Export store and schema
export { ActionableMessageCardInItemViewState };
export { ApplyConversationFlagInReadingPaneState, SetItemIdToScrollToState };
export { ClientItemId };
export { CollectionChange };
export { ConversationReadingPaneViewState };
export { DeeplinkId };
export { FlagType };
export { InstrumentationContext };
export { Item };
export { ItemId };
export { ItemMandatoryPropertiesCollectionChange };
export { ItemReadingPaneViewState };
export { ItemPartViewState };
export { LoadConversationReadingPaneForSingleMailItemSelectedState };
export { LoadConversationReadingPaneState };
export { LoadItemReadingPaneForSingleMailItemSelectedState };
export { ReloadReadingPaneState };
export { UpdateLoadedConversationState };
export { default as ItemViewState } from './store/schema/ItemViewState';
export { default as readingPaneStore } from './store/Store';
export { ClientItem };
export { SmartPillViewState };

// Lazy initialize appropriate stiches so as not to pull unnecessary code into boot
lazyInitializeStitches.importAndExecute();
